import Cart, {
    updateCartTotals,
    updateApproachingDiscounts,
    validateBasket,
    createErrorNotification,
    updateAvailability,
} from '@project/cart/cart';
import { createCustomDropdown } from '@project/components/customSelect';
import { appendToUrl } from '@assets/storeLocator/storeLocator';
import { throttle } from 'lodash';
import { getProductFromCart } from '@project/components/gtmUtils';
import { isOverBreakpoint } from '../components/utility';

export function updateProductDetails($results, selector, uuid) {
    const $updates = $results.find(selector);
    $(`.product-info.uuid-${uuid} ${selector}`).replaceWith($updates);
}

export function updateQuantitySelect($results, selector, uuid) {
    updateProductDetails($results, selector, uuid);
    createCustomDropdown(
        $(`.product-info.uuid-${uuid} ${selector} select.quantity`),
    );
}

export function parseResults(data, uuid) {
    const $results = $(data.renderedTemplate);
    if ($results.length > 0) {
        const specialHandlers = {
            '.quantity-form': updateQuantitySelect,
        };

        // Update DOM elements that do not require special handling
        [
            '.d-md-block.d-none .product-move',
            '.d-md-none .product-move',
            '.remove-product',
            '.item-detail .line-item-attributes',
            '.item-detail .item-detail__link',
            '.item-tile__image',
            '.product-card-price',
            '.update-cart-url',
        ].forEach((selector) => {
            updateProductDetails($results, selector, uuid);
        });

        Object.keys(specialHandlers).forEach((selector) => {
            specialHandlers[selector]($results, selector, uuid);
        });
    }
}

export default class extends Cart {
    constructor() {
        super();
        this.cartSummary = $('.cart-summary');
        this.body = $('body');
        this.cartSentinel = this.cartSummary.find('.cart-summary__sentinel');
        this.cartSummaryFooter = this.cartSummary.find('.cart-summary__footer');
        this.cartFooterOuterHeight = this.cartSummaryFooter.outerHeight();
        this.cartPage = this.body.find('#cartPage');
    }

    init() {
        // This class is initialized in minicart.js on the site. If you need to add custom functions to the cart, import cartridges/app_tecnica/cartridge/client/default/js/cart.js in the Cart template.
        super.init();
        if (this.cartPage.length === 0) return;
        this.handleSelectSize();
        const throttleStickyCartSummaryFooter = throttle(
            this.stickyCartSummaryFooter.bind(this),
            100,
        );
        throttleStickyCartSummaryFooter();
        $(window).on('scroll', throttleStickyCartSummaryFooter);
        $(window).on('resize', this.resizeReset.bind(this));
        this.createDropdown('.size-select');
        this.createDropdown('.quantity');
        this.moveToWishlist();
    }

    handleRemoveProduct() {
        const self = this;
        this.body.on('click', '.remove-product', async (e) => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const productID = $(this).data('pid');
            self.removeFromCart($target);
            self.productGTM = await getProductFromCart(productID);
        });
    }

    handleSelectSize() {
        const self = this;
        this.body.off(
            'change',
            '.product-detail #cartSelectSizeWrapper .select-size',
        );
        this.body.on(
            'change',
            '.product-detail #cartSelectSizeWrapper .select-size',
            (e) => {
                self.updateCartItem(e);
            },
        );
    }

    stickyCartSummaryFooter() {
        if (!isOverBreakpoint('lg') && this.cartSentinel.length > 0) {
            const cartSummaryBottomDistance = this.cartSentinel[0].getBoundingClientRect().bottom
                + this.cartFooterOuterHeight;
            if (cartSummaryBottomDistance > window.innerHeight) {
                this.cartSummaryFooter.addClass('sticky-bottom');
            } else {
                this.cartSummaryFooter.removeClass('sticky-bottom');
            }
        }
    }

    resizeReset() {
        this.cartFooterOuterHeight = this.cartSummaryFooter.outerHeight();
        if (isOverBreakpoint('lg')) {
            this.cartSummaryFooter.removeClass('sticky-bottom');
        } else {
            this.stickyCartSummaryFooter();
        }
    }

    moveToWishlist() {
        $('body').on('product:addToWishlist', (e, data) => {
            const { $target } = data;
            if ($target.hasClass('move')) {
                this.removeFromCart($target);
            }
        });
    }

    removeFromCart($target) {
        const productID = $target.data('pid');
        let url = $target.data('action');
        const uuid = $target.data('uuid');
        const urlParams = {
            pid: productID,
            uuid,
        };
        url = appendToUrl(url, urlParams);
        $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            success(data) {
                if (data.basket.items.length === 0) {
                    window.location.reload();
                } else {
                    if (
                        data.toBeDeletedUUIDs
                        && data.toBeDeletedUUIDs.length > 0
                    ) {
                        for (
                            let i = 0;
                            i < data.toBeDeletedUUIDs.length;
                            i += 1
                        ) {
                            $(`.uuid-${data.toBeDeletedUUIDs[i]}`).remove();
                        }
                    }
                    $(`.uuid-${uuid}`).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    const { totalShippingObj } = data.basket.totals;
                    $('shipping-free-label').toggleClass(
                        'd-none',
                        !totalShippingObj.isFreeShipping,
                    );
                    $('shipping-cost').toggleClass(
                        'd-none',
                        totalShippingObj.isFreeShipping,
                    );
                    updateApproachingDiscounts(
                        data.basket.approachingDiscounts,
                    );
                    $('body').trigger(
                        'setShippingMethodSelection',
                        data.basket,
                    );
                    validateBasket(data.basket);
                }
                // remove label multi product with same color
                if (!data.basket.hasDuplicates) {
                    $('.cart_size_info-productHeader').remove();
                }
                $('body').trigger('cart:update', data);
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                }
            },
        });
    }

    createDropdown(selector) {
        const $allSelect = $(
            `.custom-select-wrapper .custom-select select${selector}`,
        );
        $allSelect.each((index, select) => {
            createCustomDropdown($(select));
        });
    }

    updateCartItem(e) {
        const $currentTile = $(e.currentTarget).closest('.product-detail');
        const $inputUpdater = $currentTile.find('.update-cart-url');
        const updateProductUrl = $inputUpdater.val();
        const selectedQuantity = '1.0';
        const uuid = $inputUpdater.data('uuid');
        const pid = $(e.currentTarget).find('option:selected').data('pid');
        const form = {
            uuid,
            pid,
            quantity: selectedQuantity,
            selectedOptionValueId: pid,
        };

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success(data) {
                    parseResults(data, uuid);
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(
                        data.cartModel.approachingDiscounts,
                    );
                    updateAvailability(data.cartModel, uuid);

                    if (data.uuidToBeDeleted) {
                        $(`.uuid-${data.uuidToBeDeleted}`).remove();
                    }

                    validateBasket(data.cartModel);
                    $('body').trigger('cart:update', data);
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                    }
                },
            });
        }
    }
}
